export const APP_NATIVE_VERSION = {
  ANDROID : '2.1.9' ,
  IOS: '2.1.4',
};

export const APP_URL_TEST_VERSION = {
  ANDROID : 'https://release-zone.dev-enjoyworks.com/release/1262/Sphokidz-android' ,
  IOS: 'https://release-zone.dev-enjoyworks.com/release/1258/Sphokidz-ios',
};

export const APP_URL_PRODUCTION_VERSION = {
  ANDROID : 'https://play.google.com/store/apps/details?id=com.iaurora.sphoiler.kids' ,
  IOS: 'https://apps.apple.com/kr/app/%EC%8A%A4%ED%8F%AC%ED%82%A4%EC%A6%88-spho-kidz/id1261265548',
};

export const APP_ENV = {
  TEST : 'test' ,
  PRODUCTION: 'production',
};